import { useState } from 'react';
import {
  RootDiv,
  LoadingText,
  LoadingImg,
  LoadingBar,
  CancelButton,
  CancelText,
} from '../styles/LoadingScreen.styles';
import { CircularProgress } from '@mui/material';

interface LoadingScreenProps {
  redirectMessage: boolean;
  isFintocSuccess: boolean;
  showCancelButton: boolean;
  handleCancel: () => void;
  isLocalVendor: boolean;
  isInsurance: boolean;
}

export function LoadingScreen(props: LoadingScreenProps) {
  const [disabled, setDisabled] = useState(false);
  const {
    redirectMessage,
    isFintocSuccess,
    showCancelButton,
    handleCancel,
    isLocalVendor,
    isInsurance,
  } = props;
  return (
    <RootDiv>
      <LoadingText>
        {isLocalVendor
          ? 'Cargando...'
          : isFintocSuccess
          ? 'Validando pago...'
          : redirectMessage
          ? 'Redirigiendo...'
          : isInsurance
          ? 'Confirmando...'
          : 'Confirmando y realizando cobro...'}
      </LoadingText>
      <LoadingImg src="/assets/images/creditCard.png" />
      {!disabled && <LoadingBar />}
      {showCancelButton && (
        <CancelButton
          variant="contained"
          onClick={() => {
            if (!disabled) {
              setDisabled(true);
              handleCancel();
            }
          }}
        >
          <CancelText>
            {disabled ? (
              <>
                Cancelando <CircularProgress color="inherit" size={20} />
              </>
            ) : (
              'Cancelar'
            )}
          </CancelText>
        </CancelButton>
      )}
    </RootDiv>
  );
}
